module.exports = __webpack_public_path__ + "img/system-error-console-current-stt.06c29df8.svg";